/**
 * 지금 보고 있는 주소를 공유한다.
 * @description 이 페이지의 목적이 확산이라 공유는 여러 자리에 붙는다(상단 바, 그리고 내가 연
 *   콜랩이면 하단 CTA). 같은 동작을 두 번 적으면 한쪽만 고쳐지므로 여기 한 곳에 둔다.
 *
 *   기기가 공유 시트를 지원하면 그것을 띄우고(안드로이드·iOS·사파리), 아니면 주소를 복사한다.
 *   둘 다 막힌 환경에서는 조용히 넘어간다 — 공유는 보조 동작이라 실패가 화면을 막아서는 안 된다.
 */

/** 무슨 일이 일어났는지 — 부르는 쪽이 안내 문구를 띄울지 정한다. */
export type ShareOutcome = "shared" | "copied" | "failed";

export async function shareCurrentUrl(title: string): Promise<ShareOutcome> {
  const url = window.location.href;

  if (navigator.share) {
    try {
      await navigator.share({ title, url });
      return "shared";
    } catch {
      // 사용자가 시트를 닫은 경우도 여기로 온다 — 실패로 알리지 않는다.
      return "shared";
    }
  }

  try {
    await navigator.clipboard.writeText(url);
    return "copied";
  } catch {
    // 비보안 컨텍스트 등 클립보드가 막힌 경우. 여기서 할 수 있는 것이 없다.
    return "failed";
  }
}

/** 복사 확인 문구가 떠 있는 시간(ms). */
export const SHARE_COPIED_MS = 2000;
